import { orderBy } from 'lodash/collection'
import { produce } from 'immer'
import _ from 'lodash'

const initialState = {
    products: [],
    load: false,
    can_edit: false,
    models: [],
    select_filter: false,
    filter_params: {
        models: [],
        brand: [],
    },
}

const deleteProduct = (products, { id_product, id_supply_type, available_at }) => {
    return _.reject(
        products,
        val =>
            Number(val.id_product) === Number(id_product) &&
            Number(val.id_supply_type) === Number(id_supply_type) &&
            available_at === val.available_at
    )
}

const updateProduct = (products, item) => {
    const { id_product } = item

    // only for get emoji
    const product = products.find(v => parseInt(v.id_product) === parseInt(id_product) && Boolean(v.name_emoji))

    if (product) {
        item = produce(item, draft => {
            draft.name_emoji = product.name_emoji
            draft.name = product.name
        })
    }

    const updatedProducts = produce(products, draft => {
        const index = draft.findIndex(v => Number(v.id) === Number(item.id))
        if (index === -1) {
            draft.push(item)
        } else {
            draft[index] = { ...draft[index], ...item }
        }
    })

    return orderBy(updatedProducts, ['page_up', 'available_at'], ['asc', 'asc'])
}

const updateModels = (models, product) => {
    const { id_subcategory, subcat_name, subcat_position, cat_position, id_brand, brand_name, brand_position } = product

    if (models.findIndex(v => v.id_subcategory === id_subcategory && v.id_brand === id_brand) === -1) {
        return orderBy(
            [
                ...models,
                {
                    brand_name,
                    brand_page_up: brand_position,
                    subcat_page_up: subcat_position,
                    cat_page_up: cat_position,
                    id_brand,
                    id_subcategory,
                    subcat_name,
                },
            ],
            ['brand_page_up', 'cat_page_up', 'subcat_page_up'],
            ['asc', 'asc', 'asc']
        )
    }

    return models
}

const removeSubcatModels = (models, subcatId) => {
    return models.filter(v => v.id_subcategory !== subcatId)
}

const refreshPositions = (products, payload) =>
    produce(products, draft => {
        draft.forEach(item => {
            const position = payload.positions?.[item.id_product]?.[item.available_at]

            if (position !== undefined) {
                item.position = position
            }

            if (item.chars_sign === payload.chars_sign) {
                item.leader_price = payload.leader_price
                item.leader_country = payload.leader_country || null
            }
        })
    })

const updateMainStates = (state = initialState, { type, payload }) => {
    switch (type) {
        case 'LOADING':
            return {
                ...state,
                load: true,
            }

        case 'FETCH_STOCK_PRODUCTS':
            return {
                ...state,
                load: false,
                products: payload,
            }

        case 'DELETE_STOCK_PRODUCT':
            const { id_subcategory } =
                state.products.find(v => parseInt(v.id_product) === parseInt(payload.id_product)) || {}

            const updatedProducts = deleteProduct(state.products, payload)

            return {
                ...state,
                products: updatedProducts,
                models:
                    id_subcategory && updatedProducts.findIndex(v => v.id_subcategory === id_subcategory) === -1
                        ? removeSubcatModels(state.models, id_subcategory)
                        : state.models,
            }

        case 'UPDATE_STOCK_PRODUCT':
            const data = updateProduct(state.products, payload)

            return {
                ...state,
                products: data,
            }

        case 'REFRESH_STOCK_PRODUCT_POSITION':
            return {
                ...state,
                products: refreshPositions(state.products, payload),
            }

        case 'SET_EDIT_PRIV':
            return {
                ...state,
                can_edit: payload,
            }

        case 'FETCH_MODELS':
            return {
                ...state,
                models: payload,
            }

        case 'FETCH_FILTER_DATA':
            return {
                ...state,
                models: payload.models,
            }

        case 'UPDATE_STOCK_FILTER_MODELS':
            return {
                ...state,
                models: updateModels(state.models, payload),
            }

        case 'FETCH_FILTER_PARAMS':
            return {
                ...state,
                filter_params: payload,
            }

        case 'SET_SELECT_FILTER':
            return {
                ...state,
                select_filter: payload,
            }

        case 'RESET_STOCK_VARS':
            return {
                ...state,
                load: false,
                products: [],
                can_edit: false,
                filter_params: {},
                models: [],
            }

        default:
            return state
    }
}

const stock = (state = initialState, action) => {
    const mainStates = updateMainStates(state, action)
    return {
        ...mainStates,
    }
}

export default stock
